import api from '../api'; // Assuming 'api' is your configured Axios instance

/**
 * Purchase a coupon.
 *

 * @param {string} couponId - The ID of the coupon to purchase.
 * @param {string} city - The rewardcard of city.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const buyCoupon = async ( couponId,city) => {
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/buyCoupon";

  const requestData = {
    "couponId": couponId,
    "city": city,

  };

  try {
    // Send POST request to the server
    const response = await api.post(endpoint, requestData);

    // Check the success flag from API and throw error if it's false
    if (!response.data.Code==="000") {
      throw new Error('Failed to buy coupon: ' + response.data.message);
    }

    // Return the response data
    return response.data;

  } catch (error) {
    // Log and rethrow the error to be handled by the calling code
    console.error('Error while buying coupon:', error);
    throw error;
  }
};

export default buyCoupon;
